import { render, staticRenderFns } from "./Preview.vue?vue&type=template&id=2272c28e&scoped=true"
import script from "./Preview.vue?vue&type=script&lang=js"
export * from "./Preview.vue?vue&type=script&lang=js"
import style0 from "./Preview.vue?vue&type=style&index=0&id=2272c28e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2272c28e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlogChip: require('/home/rohit/Documents/GitHub/aibuddha-website/components/blog/chip.vue').default})
